// Set per-request by views/layout-no-menu.pug from app.locals (itself from config/site.js's
// DOMAIN/SITENAME/HIDE_UPSTREAM_LINKS env vars). The client bundle is built once at image build
// time, so these globals are the only way a runtime env var reaches React code.
export const hideUpstreamLinks = typeof window !== "undefined" && window.__HIDE_UPSTREAM_LINKS__ === true;
export const sitename = (typeof window !== "undefined" && window.__SITENAME__) || "Secret Hitler.io";
export const domain = (typeof window !== "undefined" && window.__DOMAIN__) || "secrethitler.io";
